module.exports = __webpack_public_path__ + "img/pricing-info.85e17d36.webp";